module.exports = __webpack_public_path__ + "static/media/Piggy Guy.e4baa8ef.jpg";